function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudienceSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBD8D2"
    },
    d: "M512,350.609L512,350.609c0,24.588-19.933,44.522-44.522,44.522H44.522 C19.933,395.13,0,375.197,0,350.609l0,0c0-24.588,19.933-44.522,44.522-44.522h422.957C492.066,306.087,512,326.02,512,350.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2D1D8"
    },
    d: "M172.522,128c0,21.515-17.441,38.957-38.957,38.957S94.609,149.515,94.609,128 s17.441-38.957,38.957-38.957S172.522,106.485,172.522,128z M378.435,89.043c-21.515,0-38.957,17.441-38.957,38.957 s17.441,38.957,38.957,38.957c21.515,0,38.957-17.441,38.957-38.957S399.95,89.043,378.435,89.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDFE2"
    },
    d: "M200.348,265.391v70.957H66.783v-70.957c0-36.883,29.9-66.783,66.783-66.783l0,0 C170.448,198.609,200.348,228.508,200.348,265.391z M128,100.174c-12.295,0-22.261,9.966-22.261,22.261s9.966,22.261,22.261,22.261 s22.261-9.966,22.261-22.261S140.295,100.174,128,100.174z M378.435,198.609L378.435,198.609c-36.883,0-66.783,29.9-66.783,66.783 v70.957h133.565v-70.957C445.217,228.508,415.318,198.609,378.435,198.609z M372.87,100.174c-12.295,0-22.261,9.966-22.261,22.261 s9.966,22.261,22.261,22.261c12.295,0,22.261-9.966,22.261-22.261S385.164,100.174,372.87,100.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2D1D8"
    },
    d: "M199.601,255.371c0.492,3.269,0.747,6.615,0.747,10.021v79.652H66.783v-58.502 c9.188,14.07,25.072,23.371,43.13,23.371l0,0c28.43,0,51.478-23.048,51.478-51.478l0,0 C161.391,234.772,196.079,231.972,199.601,255.371z M406.261,258.434L406.261,258.434c0,28.43-23.048,51.478-51.478,51.478l0,0 c-18.058,0-33.942-9.301-43.13-23.371v58.502h133.565v-79.653c0-3.406-0.255-6.752-0.747-10.021 C440.949,231.972,406.261,234.772,406.261,258.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A5"
    },
    d: "M464.696,350.609c0,4.61-3.738,8.348-8.348,8.348H55.652c-4.61,0-8.348-3.738-8.348-8.348 s3.738-8.348,8.348-8.348h400.696C460.958,342.261,464.696,345.998,464.696,350.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A384E2"
    },
    d: "M314.749,58.749c0,32.446-26.302,58.749-58.749,58.749s-58.749-26.302-58.749-58.749S223.554,0,256,0 S314.749,26.302,314.749,58.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B69CF7"
    },
    d: "M356.713,245.678v113.111H155.287V245.678c0-52.251,42.358-94.609,94.609-94.609h12.208 C314.355,151.069,356.713,193.427,356.713,245.678z M247.608,16.786c-18.541,0-33.57,15.031-33.57,33.571s15.031,33.57,33.57,33.57 s33.57-15.031,33.57-33.57S266.148,16.786,247.608,16.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A384E2"
    },
    d: "M355.586,236.67c0.741,4.929,1.126,9.975,1.126,15.112v107.007H155.287v-75.109 c13.856,21.219,37.81,35.245,65.043,35.245l0,0c42.876,0,77.633-34.757,77.633-77.633l0,0 C297.964,205.605,350.276,201.382,355.586,236.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC8059"
    },
    d: "M372.87,350.609c0,64.545-52.324,116.87-116.87,116.87s-116.87-52.324-116.87-116.87 s52.324-116.87,116.87-116.87S372.87,286.063,372.87,350.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M333.913,350.609c0,43.03-34.883,77.913-77.913,77.913s-77.913-34.883-77.913-77.913 S212.97,272.696,256,272.696S333.913,307.578,333.913,350.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC8059"
    },
    d: "M278.261,350.609c0,12.295-9.966,22.261-22.261,22.261c-12.295,0-22.261-9.966-22.261-22.261 c0-12.295,9.966-22.261,22.261-22.261C268.295,328.348,278.261,338.314,278.261,350.609z M264.348,503.652V403.478 c0-4.61-3.738-8.348-8.348-8.348s-8.348,3.738-8.348,8.348v100.174c0,4.61,3.738,8.348,8.348,8.348S264.348,508.262,264.348,503.652 z M264.348,297.739V197.565c0-4.61-3.738-8.348-8.348-8.348s-8.348,3.738-8.348,8.348v100.174c0,4.61,3.738,8.348,8.348,8.348 S264.348,302.349,264.348,297.739z M417.391,350.609c0-4.61-3.738-8.348-8.348-8.348H308.87c-4.61,0-8.348,3.738-8.348,8.348 s3.738,8.348,8.348,8.348h100.174C413.654,358.957,417.391,355.219,417.391,350.609z M211.478,350.609 c0-4.61-3.738-8.348-8.348-8.348H102.957c-4.61,0-8.348,3.738-8.348,8.348s3.738,8.348,8.348,8.348H203.13 C207.741,358.957,211.478,355.219,211.478,350.609z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceSvgrepoCom);
export default __webpack_public_path__ + "static/media/audience-svgrepo-com.eb7ee48678f2b92ee73b6bce54f58385.svg";
export { ForwardRef as ReactComponent };